import { EventItem } from '@scorenco/components';
import { Types } from '@scorenco/core';

export type GameProps = {
  game?: { game: Types.Tournaments_Game };
};

export const Game = ({ game }: GameProps) => {
  const homeTeam = game?.game?.home_engagement;
  const awayTeam = game?.game?.away_engagement;
  const homeScore = game?.game?.home_score;
  const awayScore = game?.game?.away_score;
  const status = game?.game?.status;
  const homeShoutout = game?.game?.home_shootout;
  const awayShoutout = game?.game?.away_shootout;

  if (game?.game?.event_id) {
    return (
      <EventItem
        event={game?.game?.event?.detail?.[0]}
        showPlace={false}
        showCompetition={false}
        isTournament={true}
        scoreSubscription={true}
      />
    );
  }

  return (
    <EventItem
      event={{
        id: game?.game?.id,
        status: status,
        time: game?.game?.date,
        date: game?.game?.date,
        teams: [
          {
            id: homeTeam?.team?.id,
            logo: homeTeam?.team?.logo,
            score: homeScore,
            name_in_club: homeTeam?.team?.name || homeTeam?.name,
            name_in_competition: homeTeam?.team?.name || homeTeam?.name,
            role: 'home',
            data: {
              shootout: homeShoutout,
            },
          },
          {
            id: awayTeam?.team?.id,
            logo: awayTeam?.team?.logo,
            score: awayScore,
            name_in_club: awayTeam?.team?.name || awayTeam?.name,
            name_in_competition: awayTeam?.team?.name || awayTeam?.name,
            role: 'away',
            data: {
              shootout: awayShoutout,
            },
          },
        ],
      }}
      showPlace={false}
      showCompetition={false}
      isTournament={true}
    />
  );
};
